import { usePaymentQueries } from "./usePaymentQueries";
import { usePaymentMutations } from "./usePaymentMutations";
import { PaymentMethod, PaymentMethodInput } from "@/types/payment";

export const usePaymentOperations = (contactId: string) => {
  const { paymentMethods, fetchPaymentMethods } = usePaymentQueries(contactId);
  const { isLoading, addPaymentMethod, deletePaymentMethod } = usePaymentMutations(contactId);

  return {
    isLoading,
    paymentMethods,
    fetchPaymentMethods,
    addPaymentMethod,
    deletePaymentMethod
  };
};